import * as React from "react";
import { Grid } from "tabler-react";
import SiteWrapper from "../../SiteWrapper.react";
import ControladoresLocalidadesForm from "../../Catalogos/ControladoresLocalidades/ControladoresLocalidadesForm";

function ControladoresLocalidadesPage() {
  return (
    <SiteWrapper>
      <Grid.Col sm={12} lg={12}>
        <ControladoresLocalidadesForm />
      </Grid.Col>
    </SiteWrapper>
  );
}
export default ControladoresLocalidadesPage;
